import React from 'react';

function inicio() {
    return (
    <p>hola Administrador</p>
    );
  }
  
export default inicio;
  